import createSvgIcon from '@ixigo/icons/utils/createSvgIcon';
import { Fragment } from 'react';

export const EmergencyFilled = createSvgIcon(
	<Fragment>
		<path
			d="M5.99158 12.363C5.99158 9.04436 8.68361 6.35424 12.0037 6.35604C15.3306 6.35784 18.0097 9.09482 18.0097 12.4207V16.0465C18.0097 16.5712 17.5839 16.9969 17.059 16.9969H6.94228C6.41736 16.9969 5.99158 16.5712 5.99158 16.0465V12.363Z"
			fill="#AF2B2B"
		/>
		<path
			d="M12.0037 6.35604C15.3306 6.35784 18.0097 9.09482 18.0097 12.4207V16.0465C18.0095 16.4009 17.8141 16.7089 17.5262 16.8721C13.9733 16.3375 10.1387 16.2137 6.61017 16.9356C6.24933 16.8008 5.99178 16.4541 5.99158 16.0465V12.363C5.99158 9.04436 8.68361 6.35424 12.0037 6.35604Z"
			fill="#DA3732"
		/>
		<path
			d="M11.4596 2.37296V4.87062C11.4596 5.57054 12.5412 5.56107 12.5412 4.87062V2.37296C12.5412 1.67304 11.4596 1.6825 11.4596 2.37296Z"
			fill="#DA3732"
		/>
		<path
			d="M11.4596 2.37296V4.87062C11.4596 5.57054 12.5412 5.56107 12.5412 4.87062V2.37296C12.5412 1.67304 11.4596 1.6825 11.4596 2.37296Z"
			fill="#DA3732"
		/>
		<path
			d="M11.4596 2.37296V4.87062C11.4596 5.57054 12.5412 5.56107 12.5412 4.87062V2.37296C12.5412 1.67304 11.4596 1.6825 11.4596 2.37296Z"
			fill="#DA3732"
		/>
		<path
			d="M4.2509 5.95317C4.88687 6.49055 5.52283 7.02828 6.1588 7.56566C6.68857 8.01386 7.45173 7.24768 6.92347 6.80122C6.28751 6.26385 5.65154 5.72611 5.01558 5.18873C4.4858 4.74053 3.72265 5.50672 4.2509 5.95317Z"
			fill="#DA3732"
		/>
		<path
			d="M1.90823 12.2172C2.74105 12.2172 3.57386 12.2172 4.40667 12.2172C5.10675 12.2172 5.09728 11.1359 4.40667 11.1359C3.57386 11.1359 2.74105 11.1359 1.90823 11.1359C1.20816 11.1359 1.21762 12.2172 1.90823 12.2172Z"
			fill="#DA3732"
		/>
		<path
			d="M18.8887 5.19018C18.2523 5.72719 17.6156 6.26421 16.9793 6.80122C16.4509 7.24759 17.2131 8.0135 17.744 7.56566C18.3803 7.02864 19.017 6.49163 19.6533 5.95461C20.1818 5.50824 19.4196 4.74233 18.8887 5.19018Z"
			fill="#DA3732"
		/>
		<path
			d="M22.0918 11.1359C21.259 11.1359 20.4261 11.1359 19.5933 11.1359C18.8933 11.1359 18.9027 12.2172 19.5933 12.2172C20.4261 12.2172 21.259 12.2172 22.0918 12.2172C22.7918 12.2172 22.7824 11.1359 22.0918 11.1359Z"
			fill="#DA3732"
		/>
		<path
			d="M18.0083 17.3692H5.99272C4.28728 17.3692 4.28729 20.0132 5.99272 20.0132H18.0083C19.7137 20.0132 19.7137 17.3692 18.0083 17.3692Z"
			fill="#DA3732"
		/>
	</Fragment>,
	'EmergencyFilled',
);

export default EmergencyFilled;
